module.exports = __webpack_public_path__ + "assets/img/logo.2f34c9dc.gif";